export const companySmsSendingRuleModalMode = {
	CREATE: "CREATE",
	EDIT: "EDIT",
	DUPLICATE_AND_CREATE: "DUPLICATE_AND_CREATE",
} as const

export type CompanySmsSendingRuleModalMode =
	keyof typeof companySmsSendingRuleModalMode
